module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content single-content"
  }, [_c('div', {
    staticClass: "textbox-bounds textbox-bounds-unbound-double"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('div', {
    staticClass: "auditionLogo"
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": "images/logo.png",
      "alt": "החצר"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "auditionLogoSubtitle"
  }, [_vm._v("אנסמבל קולי")])]), _vm._v(" "), _c('h3', [_vm._v("ברוכים הבאים לחצר!")]), _vm._v(" "), _c('p', [_vm._v("שלחנו למייל שלכם את ההנחיות לאודישן. חשוב מאוד לעבור עליהן ולהגיע מוכנים. ניתן לצפות בהנחיות\n\t\t\t\t\t\t\t"), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#FF632B",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://yardbands.com/admin_uploads/%D7%94%D7%A0%D7%97%D7%99%D7%95%D7%AA%20%D7%9C%D7%9E%D7%95%D7%A2%D7%9E%D7%93%20%D7%9C%D7%90%D7%95%D7%93%D7%99%D7%A9%D7%9F%20%D7%9C%D7%90%D7%A0%D7%A1%D7%9E%D7%91%D7%9C.pdf"
    }
  }, [_vm._v("גם כאן.")])]), _vm._v(" "), _c('h3', [_vm._v("שאלות?")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("אנחנו כאן בשבילכם.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("במייל:")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#c7b7a5",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "mailto:OFFICE@YARDBANDS.COM"
    }
  }, [_vm._v("office@yardbands.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("טלפון:")]), _vm._v("\n\t\t\t\t\t\t\t 054-7737094. אם לא עונים - השאירו הודעת ווצאפ ונחזור אליכם בהקדם.\n\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("נתראה בקרוב")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://yardbands.com"
    }
  }, [_c('label', {
    staticClass: "login-next-button"
  }, [_vm._v("חזרה למסך הראשי")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cba9edc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PaymentEnsamble.vue
// module id = 120
// module chunks = 0